<template>
  <v-card
    flat
    outlined
    class="position-relative"
    :class="{ 'border-nitro border border-5' : block.selected }"
  >
    <div
      :style="[!block.selected ? { 'background-color': trail.lighten_color, 'color': 'black' } : { 'background-color': 'white'}]"
      class="font-weight-bold p-3 pointer-on-hover"
      @click="onClick(block)"
    >
      {{ trail.acronym }} | {{ block.name }}
    </div>

    <CollapseItems
      :border-radius-header="'rounded-t-lg'"
      :background-color-header="'grey lighten-4'"
      :padding-header="'10px'"
      :padding-container-header="'p-0'"
      :show-border-bottom-header="false"
      class="p-2"
    >
      <template #title>
        <div>
          <div class="font-weight-medium block-title-color mb-2 h6">
            Descrição do bloco
          </div>
        </div>
      </template>
      <template #content>
        <div class="rounded-b-lg p-3 grey lighten-3 font-weight-medium">
          <p>{{ block.description }}</p>
        </div>
      </template>
    </CollapseItems>
    <CollapseItems
      :border-radius-header="'rounded-t-lg'"
      :background-color-header="block.selected ? 'grey lighten-4' : `${trail.color}33`"
      :padding-header="'10px'"
      :padding-container-header="'p-0'"
      :show-border-bottom-header="false"
      class="p-2"
    >
      <template #title>
        <div>
          <div class="font-weight-medium block-title-color mb-2 h6">
            Visualizar os módulos
          </div>
        </div>
      </template>
      <template #content>
        <v-card-text class="p-3 grey lighten-4 rounded-b-lg">
          <v-card
            class="grey lighten-4"
            elevation="0"
            tile
            style="height: 220px; overflow-y: auto !important;"
          >
            <v-row
              v-for="(theme, index) in themes"
              :key="theme.id"
              class="pointer-on-hover"
              style="border-bottom: 1px solid #a9a9a973;"
              @click="selectedModule = theme"
            >
              <v-col
                cols="2"
                class="d-flex align-center"
              >
                <i class="fa fa-play-circle fa-2x" />
              </v-col>
              <v-col cols="10">
                <span class="font-weight-medium">
                  {{ `0${index+1}.` }}
                </span>
                <span class="font-weight-bold">{{ theme.name }}.</span>
                <span class="font-weight-medium">{{ theme.description }}.</span>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </template>
    </CollapseItems>

    <div class="text-center">
      <v-dialog
        v-model="showDialog"
        :overlay-opacity="DEFAULT_MODAL_OPACITY"
        :overlay-color="DEFAULT_MODAL_OVERLAY_COLOR"
        width="600"
      >
        <ModulePreview
          v-if="showDialog"
          :module="selectedModule"
        >
          <div class="d-flex justify-content-center w-100">
            <v-btn
              color="primary"
              text
              @click="selectedModule = null"
            >
              Fechar
              <v-icon
                right
                dark
              >
                fa fa-times
              </v-icon>
            </v-btn>
          </div>
        </ModulePreview>
      </v-dialog>
    </div>
  </v-card>
</template>


<script>

import CollapseItems from "@/common/components/CollapseItems.vue";
import ModulePreview from "@/student/pages/module/components/ModulePreview";
import { mapMutations, mapGetters } from 'vuex';
import {DEFAULT_MODAL_OPACITY, DEFAULT_MODAL_OVERLAY_COLOR} from "@/student/constants/general"

export default {
  components: {
    CollapseItems,
    ModulePreview,
  },
  props: {
    block: {
      type: Object,
      required: true,
    },
    trail:{
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      showDialog: false,
      selectedModule: null,
      activeTab: 0,
      DEFAULT_MODAL_OPACITY,
      DEFAULT_MODAL_OVERLAY_COLOR,
    }
  },
  computed:{
    ...mapGetters(['trails', 'selectedTrailId']),
    themes(){
      return this.block.themes;
    },
    selectedTrail() {
      return this.trails.find(t => t.id == this.selectedTrailId)
    },
  },
  watch:{
    selectedModule(value){
      this.showDialog = !!value
    }
  },
  methods:{
    ...mapMutations(['SET_TRAILS',]),
    onClick(block) {
      block = {...block, selected: !block.selected};
      this.SET_TRAILS(this.trails.map(t=> {
        t.blocks = t.blocks.map(b=> b.id === block.id ? block : b)
        return t
      }))
    },
  }
}
</script>
<style scoped lang="scss">
@import "../../../../../sass/main/01-settings/colors";

.block-title-color {
  color: $gray-800 !important;
}
</style>
